package org.example.zone360.components

import kotlinx.browser.document
import kotlinx.coroutines.suspendCancellableCoroutine
import kotlinx.datetime.internal.JSJoda.DateTimeFormatter
import kotlinx.datetime.internal.JSJoda.Instant
import kotlinx.datetime.internal.JSJoda.LocalDate
import kotlinx.datetime.internal.JSJoda.ZoneId
import org.jetbrains.compose.web.attributes.InputType
import org.w3c.dom.HTMLVideoElement
import org.w3c.dom.url.URL
import kotlin.coroutines.resumeWithException

fun String.formatSessionHours(): String {
    return try {
        val timestamp = this.toLongOrNull() ?: return "N/A"
        val dateTime = Instant.ofEpochMilli(timestamp.toDouble()).atZone(ZoneId.systemDefault())
        val formatter = DateTimeFormatter.ofPattern("HH:mm")
        dateTime.format(formatter)
    } catch (e: Exception) {
        "N/A"
    }
}
fun String.formatSessionHoursAmPm(): String {
    return try {
        val timestamp = this.toLongOrNull() ?: return ""
        val dateTime = Instant.ofEpochMilli(timestamp.toDouble()).atZone(ZoneId.systemDefault())

        // Access hour and minute as properties
        val hour = dateTime.hour()
        val minute = dateTime.minute()

        // Format hour in 12-hour format
        val hour12 = when {
            hour == 0 -> 12
            hour > 12 -> hour - 12
            else -> hour
        }

        // Determine AM/PM
        val amPm = if (hour < 12) "AM" else "PM"

        // Use string template instead of format
        "${hour12}:${minute.toString().padStart(2, '0')} $amPm"
    } catch (e: Exception) {
        "N/A"
    }
}
fun String.formatSessionDate(): String {
    return try {
        val timestamp = this.toLongOrNull() ?: return "-"
        val dateTime = Instant.ofEpochMilli(timestamp.toDouble()).atZone(ZoneId.systemDefault())
        val formatter = DateTimeFormatter.ofPattern("dd/MM/yyyy")
        dateTime.format(formatter)
    } catch (e: Exception) {
        "N/A"
    }
}
//Int format of minutes
fun Number.formatSessionMinutes(): String {
    return try {
        val totalSeconds = this.toDouble().toInt()
        val minutes = totalSeconds / 60
        val seconds = totalSeconds % 60
        "$minutes:${seconds.toString().padStart(2, '0')}"
    } catch (e: Exception) {
        "N/A"
    }
}
//String format of minutes

fun Number.formatToPercentage(total: Number): String {
    return try {
        val value = this.toDouble()
        val totalValue = total.toDouble()

        // Add more detailed logging

        if (totalValue > 0) {
            val percentage = ((value / totalValue) * 100.0).toInt()
            "$percentage%"
        } else {
            "0%"
        }
    } catch (e: Exception) {
        "N/A"
    }
}

fun formatDateWithDashes(dateString: String): String {
    return try {
        if (dateString == "0" || dateString.isBlank()) return "" // or ""
        val inputFormatter = DateTimeFormatter.ofPattern("yyyyMMdd")
        val outputFormatter = DateTimeFormatter.ofPattern("yyyy-MM-dd")
        LocalDate.parse(dateString, inputFormatter).format(outputFormatter)
    } catch (e: Exception) {
        "" // fallback if somehow malformed
    }
}
fun String.titleized(): String =
    replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() }
